import * as React from "react";

import type { ForwardRefComponent } from "@fluentui/react-components";

import { renderAppTab } from "@1js/acui-tablist";
import { useTab } from "./useTab";

import { useTabStyles } from "./useTabStyles.styles";
import type { TabProps } from "./Tab.types";

export const Tab: ForwardRefComponent<TabProps> = React.memo(
  React.forwardRef<HTMLButtonElement, TabProps>((props, ref) => {
    const state = useTab(props, ref);
    useTabStyles(state);
    return renderAppTab(state);
  })
) as ForwardRefComponent<TabProps>;

Tab.displayName = "next/Tab";
